import { usePermissions } from "../../../../server/auth/use-permissions";
import { isEmailChannel } from "../../../channels/types";
import type { UseMomentProperties } from "../../../moment-card/types";
import { getTargetType } from "../../../to/use-to-target";

type EmployeeNewsletterMomentInfo = Pick<
  UseMomentProperties,
  | "use_lexical_editor"
  | "channel"
  | "only_additional_recipients"
  | "target_manager"
  | "target_connection_type"
  | "target_channel"
  | "notify_channel"
>;

function isNonEmployeeNewsletter(moment: EmployeeNewsletterMomentInfo): boolean {
  const { toTarget } = getTargetType(moment);

  return (
    !moment.use_lexical_editor &&
    (!moment.channel || isEmailChannel(moment.channel)) &&
    toTarget !== "employee"
  );
}

export function useMomentClonable(moment?: EmployeeNewsletterMomentInfo):
  | {
      loading: true;
      clonable: null;
    }
  | { loading: false; clonable: boolean | "warn_first" } {
  const { ce_admin, isLoading } = usePermissions();

  if (!moment || isLoading) return { loading: true, clonable: null };

  // Only ce_admins can clone non-employee newsletters
  const nonEmployeeNewsletter = isNonEmployeeNewsletter(moment);

  return {
    loading: false,
    clonable: !nonEmployeeNewsletter ? true : ce_admin ? "warn_first" : false,
  };
}
